module.exports = __webpack_public_path__ + "static/media/seeds-of-life-thumbnail_tablet.c8b98fed.jpg";